import Copy from '@svg/copy.svg?react';
import Copied from '@svg/v-circle-outline-small.svg?react';
import React, { useState } from 'react';
import './copy-button.scss';

export interface CopyButtonProps {
    value: string;
    timeout?: number;
    onCopySuccess?: () => void;
}

const DEFAULT_MS = 1200;

const CopyButton: React.FC<CopyButtonProps> = ({
    value,
    timeout = DEFAULT_MS,
    onCopySuccess
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async (e: React.MouseEvent) => {
        e.stopPropagation();
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            if(onCopySuccess) {
                onCopySuccess();
            }
        } catch (err) {
            console.error('Copy to clipboard failed', err);
        }
        setTimeout(() => {
            setCopied(false);
        }, timeout);
    };

    return (
        <button
            type="button"
            className={`copy-button ${copied ? 'copied' : 'copy'}`}
            onClick={handleCopy}
        >
            {copied ? (
                <><Copied className="copied-icon" /> Copied</>
            ) : (
                <><Copy className="copy-icon" /> Copy</>
            )}
        </button>
    );
};

export default CopyButton;
